import { useTranslation } from "react-i18next";
import { PLACEHOLDER_IMAGES } from "../../utility/placeholders";
import "./ProviderCard.scss";

const ProviderCard = ({ provider, categoryLabel, onClick }) => {
  const { t } = useTranslation("marketplace");
  const badges = Array.isArray(provider.badges) ? provider.badges.slice(0, 2) : [];

  return (
    <button className="provider-card" onClick={onClick} type="button">
      <div className="provider-card__visual">
        <img
          src={provider.imageUrl}
          alt={provider.name}
          draggable={false}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = PLACEHOLDER_IMAGES.PROVIDER;
          }}
        />
      </div>

      <div className="provider-card__content">
        <div className="provider-card__meta">
          {categoryLabel && <span>{categoryLabel}</span>}
          {provider.redirectionUrl && (
            <span>{t("provider.external", { defaultValue: "Site externe" })}</span>
          )}
        </div>

        <h3>{provider.name}</h3>
        <p>{provider.description || provider.fullDescription}</p>

        {badges.length > 0 && (
          <div className="provider-card__badges">
            {badges.map((badge) => (
              <span key={badge}>{badge}</span>
            ))}
          </div>
        )}

        <span className="provider-card__cta">
          {t("provider.view_provider", { defaultValue: "Voir le fournisseur" })}
        </span>
      </div>
    </button>
  );
};

export default ProviderCard;
